<template>
    <div>
        <transition name="modal">
            <div v-if="open" class="modal" tabindex="-1" role="dialog" style="display: block;" @click="$emit('close')">
                <div class="modal-dialog" role="document" @click.stop>
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 v-if="title" class="modal-title">
                                {{ title }}
                            </h3>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                                <fa-icon :icon="['fal', 'times']" />
                            </button>
                        </div>
                        <div v-if="$slots.default" class="modal-body">
                            <slot></slot>
                        </div>
                        <div v-if="$slots.footer" class="modal-footer">
                            <slot name="footer"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div v-if="open" class="modal-backdrop"></div>
        </transition>
    </div>
</template>
<script>
export default {
    props: ['open', 'title'],
    watch: {
        isOpen(newVal) {
            if(newVal) {
                document.body.classList.add('modal-open');
            } else {
                document.body.classList.remove('modal-open');
            }
        }
    }
}
</script>
